"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AccountSelectViewLayout = require("./AccountSelectViewLayout");
Object.keys(_AccountSelectViewLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AccountSelectViewLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AccountSelectViewLayout[key];
    }
  });
});